/**
 * emptyStateRenderer — shared "no X yet" renderer used by the placeholder
 * journal tabs (Relics, Pet, Visitors, Home Stage).
 *
 * Centralised so the four placeholder tabs are essentially one-liners; if
 * the empty-state styling changes (drop-shadow, italic, font), the change
 * lands here and every placeholder tab inherits it. WhispersTab and
 * RumorsTab roll their own slightly richer empty-states inline since
 * they also have a populated path.
 */

import * as Phaser from 'phaser';
import {
  JOURNAL_FONT,
  JOURNAL_INK_MUTED,
  JOURNAL_FONT_SIZE,
  JOURNAL_LAYOUT,
} from './journalTheme';
import type { JournalTabState } from './journalDispatch';

export function renderEmptyStateTab(
  scene: Phaser.Scene,
  container: Phaser.GameObjects.Container,
  state: JournalTabState,
): void {
  container.removeAll(true);
  const text = scene.add.text(0, 24, state.emptyMessage, {
    fontFamily: JOURNAL_FONT,
    fontSize: JOURNAL_FONT_SIZE.EMPTY_STATE,
    color: JOURNAL_INK_MUTED,
    fontStyle: 'italic',
    wordWrap: {
      width: JOURNAL_LAYOUT.CONTENT_WIDTH - JOURNAL_LAYOUT.CONTENT_PAD_X * 2,
    },
  });
  container.add(text);
}
